import { Link } from 'react-router-dom';

import { SmartTableCellProps } from '@/components/ui/daisy';
import { ROUTES } from '@/utils/routes';

import { ScheduledLessonKlass } from '../types';
import CellSkeleton from '@/components/shared/tables/CellSkeleton';

export default function KlassCell({
  item,
}: SmartTableCellProps<{ klass: ScheduledLessonKlass | null }>) {
  const { klass } = item;

  if (!klass) return null;

  if (klass.isLoading) return <CellSkeleton />;

  if (!klass.name) return null;

  return (
    <Link
      to={ROUTES.ADMIN.CLASSES.INFO({
        name: klass.name.replace('#', ''),
      })}
      className="text-primary underline"
    >
      {klass.name}
    </Link>
  );
}
